import React from 'react';
import styled from 'styled-components';

interface AddToFavoritesProps {
  didSet: boolean;
  className: string;
}

const AddToFavoritesStyled = styled.div<AddToFavoritesProps>`
  opacity: 90%;
  background-color: #038cca;
  border-radius: 4px;
  height: 56px;
  width: ${({ didSet }): string => (didSet ? '240px' : '273px')};
  top: 80%;
  left: 0;
  right: 0;
  display: table;
  position: fixed;

  .add-to-favorites-text-container {
    text-align: center;
    display: table-cell;
    vertical-align: middle;
  }

  .add-to-favorites-icon {
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    color: #fff;
    font-size: 16px;
    padding-right: 15px;
    padding-left: 15px;
  }

  .add-to-favorites-text {
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    color: #fff;
    font-size: 16px;
    padding-top: 0px;
    font-family: 'SourceSansPro-Regular';
    line-height: 20px;
  }

  @media screen and (max-width: 960px) {
    background-color: #000;
    height: 123px;
    width: 123px;
    top: 50%;

    .add-to-favorites-text-container {
      display: inline-block;
      margin-top: ${({ didSet }): string => (didSet ? '10px' : '21px')};
    }

    .add-to-favorites-text {
      padding-top: ${({ didSet }): string => (didSet ? '1px' : '8px')};
      display: ${({ didSet }): string => (didSet ? 'block' : 'table-cell')};
    }
    .remove-from-favorites-icon {
      margin-top: 10px;
      margin-bottom: 7px;
    }

    .add-to-favorites-icon {
      display: inline;
    }

    .favorites-removed-title {
      padding-top: 8px;
    }
  }
`;

const AddToFavorites: React.FC<AddToFavoritesProps> = ({ didSet }) => {
  return (
    <AddToFavoritesStyled
      didSet={didSet}
      className="center fl tc flex-row z-7 pr4-l"
      data-id="add-to-favorites-modal"
    >
      <div className="add-to-favorites-text-container">
        <span className="add-to-favorites-icon">
          {didSet ? (
            <i className="icon-check f-subheadline f1-l white" />
          ) : (
            <i className="icon-x f5 white" />
          )}
        </span>
        {didSet ? (
          <>
            <p className="add-to-favorites-text">Added to</p>
            <p className="add-to-favorites-text" style={{ paddingLeft: '2px' }}>
              Your Favorites
            </p>
          </>
        ) : (
          <h1 className="add-to-favorites-text">Removed from Your Favorites</h1>
        )}
      </div>
    </AddToFavoritesStyled>
  );
};

export default AddToFavorites;
